import {ClientEventType} from "./ClientEventType";
import {AchievementName} from "../../../game/achievements/models/AchievementName";
import {IsoDate} from "../../../pseudo-types/DateTypes";
import {SpanFileTime} from "../../../span/types/SpanFileTime";
import {IosServerName} from "../../../orders/models/OrderRecord";
import {ClientEventService} from "../ClientEventService";

export type ClientEventRecords = ReadonlyArray<ClientEventRecord>;

export interface ClientEventRecord {
    readonly type: ClientEventType;
}

export type OrderClientEventRecords = ReadonlyArray<OrderClientEventRecord>;

export interface OrderClientEventRecord extends ClientEventRecord {
    readonly orderNumber: number;
    readonly serverName: IosServerName | null;
}

export interface IressOrderClientEventRecord extends OrderClientEventRecord {
    readonly serverName: IosServerName;
}

const OrderEventTypes = [ClientEventType.ORDER_CREATED, ClientEventType.ORDER_UPDATED, ClientEventType.ORDER_COMPLETED];

export function isOrderClientEvent(event: ClientEventRecord): event is OrderClientEventRecord {
    return OrderEventTypes.includes(event.type);
}

export function isIressOrderClientEvent(event: OrderClientEventRecord): event is IressOrderClientEventRecord {
    return event.serverName != null;
}

export interface PortfoliosUpdatedClientEventRecord extends ClientEventRecord {
    readonly type: ClientEventType.PORTFOLIO_UPDATED;
    readonly portfolioIds: ReadonlyArray<number>;
}

export function isPortfoliosUpdatedClientEvent(event: ClientEventRecord): event is PortfoliosUpdatedClientEventRecord {
    return event.type === ClientEventType.PORTFOLIO_UPDATED;
}

export function isPortfolioClientEventFor(event: ClientEventRecord, id: number): boolean {
    return isPortfoliosUpdatedClientEvent(event) && event.portfolioIds.includes(id);
}

export interface AchievementUnlockedClientEventRecord extends ClientEventRecord {
    readonly name: AchievementName;
    readonly value: number;
}

export function isAchievementUnlockedClientEvent(event: ClientEventRecord): event is AchievementUnlockedClientEventRecord {
    return event.type === ClientEventType.ACHIEVEMENT_UNLOCKED;
}

export interface SpanModelUpdatedClientEventRecord extends ClientEventRecord {
    readonly businessDate: IsoDate;
    readonly fileTime: SpanFileTime;
}

export function isSpanModelUpdatedClientEvent(event: ClientEventRecord): event is SpanModelUpdatedClientEventRecord {
    return event.type === ClientEventType.SPAN_MODEL_UPDATED;
}
